import Link from 'next/link';

import { ArrowRightNew } from '@/components/SvgComponents';

import styles from './index.module.scss';

export const ToolbarBanner = () => {
  return (
    <div
      className={styles.wrapper}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <h1>Order the number you like</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna.
      </p>
      <Link
        href='/number-sale'
        aria-label='Buy Number'
        rel='noopener noreferrer'
      >
        <a>
          Buy <ArrowRightNew />
        </a>
      </Link>
    </div>
  );
};
